import { useDispatch, useSelector } from "react-redux";
import MenuItem from "./menuItem";
import { AuthorityMenu } from "./authority-menu";
import { AuthorityUserMenu } from "./authorityuser-menu";
import useRoles from "../../constants/useRoles";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import UnsavedChangesModal from "./UnsavedChangesModal";
import { ADD, CLEAR_FORM_STATE } from "../../redux/actions/applicationType";

const SideBarMenu = (props) => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const formValueState = useSelector((state) => state.formState);

  const [showModal, setShowModal] = useState(false);
  const [pendingRoute, setPendingRoute] = useState(null);

  const navigate = useNavigate();
  const { readOnly, readWrite, admin } = useRoles();

  if (!user) return null;

  const { user_type } = user;
  let menuToRender = [];

  if (user_type === "AUTHORITY") {
    if (admin) {
      menuToRender = AuthorityMenu(props.notificationCount > 99 ? "99+" : props.notificationCount);
    } else if (readWrite) {
      menuToRender = AuthorityUserMenu(
        props.notificationCount > 99 ? "99+" : props.notificationCount
      );
    } else if (readOnly) {
      menuToRender = AuthorityUserMenu(props.notificationCount).filter(
        (_, index) => index !== 0 && index !== 1
      );
    }
  }

  return (
    <div className="sidebar-menu">
      <ul className="menu" data-bs-theme="dark">
        <li className="sidebar-title" data-bs-theme="dark"></li>

        {menuToRender.map((item, index) => (
          <MenuItem
            key={"menu" + index}
            item={item}
            index={index}
            isDirty={formValueState?.isDirty}
            setPendingRoute={setPendingRoute}
            setShowModal={setShowModal}
          />
        ))}
      </ul>
      <UnsavedChangesModal
        show={showModal}
        onLeave={() => {
          dispatch({
            type: ADD,
            payload: false,
            propertyKey: "isDirty"
          });
          setShowModal(false);
          if (pendingRoute) {
            navigate(pendingRoute);
            setPendingRoute(null);
          }
        }}
        onStay={() => {
          setShowModal(false);
          setPendingRoute(null);
        }}
      />
    </div>
  );
};

export default SideBarMenu;
